import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "caass-staff-manual-staff-table",
	templateUrl: "./staff-manual-staff-table.component.html",
	styleUrls: ["./staff-manual-staff-table.component.css"],
})
export class StaffManualStaffTableComponent implements OnInit {
	constructor() {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.UpdateData();
	}

	ngOnChanges() {
		this.UpdateData();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Output() AddToList: EventEmitter<any> = new EventEmitter();

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	@Input() loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPersons: any = [];
	@Input() lstPerson: any = [];

	//Filter lists
	lstPersonTypeDesc: any = [];
	lstStaffTitle: any = [];
	lstHasEmailDesc: any = [];
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StaffID", header: "Staff ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "SchoolFullName", header: "School" },
		{ field: "PersonTypeDesc", header: "Person Type" },
		{ field: "StaffTitle", header: "Staff Title" },
		{ field: "EmailDesc", header: "Email" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////
	UpdateData() {
		this.lstPersonTypeDesc = [];
		this.lstStaffTitle = [];
		this.lstActiveDesc = [];

		if (this.lstPerson == undefined || this.lstPerson.length == 0) {
			return;
		}

		this.lstPersonTypeDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.PersonTypeDesc))).sort();
		this.lstStaffTitle = Array.from(new Set(this.lstPerson.map((item: any) => item.StaffTitle))).sort();
		this.lstHasEmailDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.HasEmailDesc))).sort();
		this.lstActiveDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ActiveDesc))).sort();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////
	onAddToList() {
		var lstEmail: any = [];

		for (var z = 0; z < this.SelectedPersons.length; z++) {
			var next = this.SelectedPersons[z];

			var newData: any = {
				Active: next.Active,
				ActiveDesc: next.ActiveDesc,
				Email: next.EmailDesc,
				FirstName: next.FirstName,
				PersonTypeDesc: next.PersonTypeDesc,
				StaffTitle: next.StaffTitle,
				LastName: next.LastName,
				PersonID: next.PersonID,
				SchoolFullName: next.SchoolFullName,
				StaffID: next.StaffID,
			};

			lstEmail = [...lstEmail, newData];
		}

		// this.AddToList.emit(this.SelectedPersons);
		this.AddToList.emit(lstEmail);
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	////////////////////////////////////////////
}
